/**
 * sessionStorage entries that belong to the signed-in player and must never reach the next one on a
 * shared kiosk or family phone. apiService clears them on every sign-out and sign-in.
 */

/** The guided Add money intent (features/money/guidedAddIntent.ts). */
export const GUIDED_ADD_INTENT_KEY = 'guided-add-money';

export function clearPlayerSessionStorage(): void {
  try {
    window.sessionStorage.removeItem(GUIDED_ADD_INTENT_KEY);
  } catch {
    // Storage unavailable: nothing was stored either.
  }
}
